// Builder buttons link to the next step with a full URL such as
// "/pages/customizer/#/<variant>/step2". The current URL also carries
// "?variant=…&step=…" (see customizerUrlRecovery), so window.open() treats that link
// as a different page and reloads it: the step guard never runs and the customer is
// sent back to step 1 without the missing required fields being marked. Links to the
// customizer page the customer is already on therefore navigate inside the router.

const trimTrailingSlash = (pathname) => pathname.replace(/\/+$/, "");

/**
 * @param {string} link - Link as configured in Builder
 * @param {Location|URL} currentLocation
 * @returns {string|null} Router path (e.g. "/52560498360656/step2") or null for any other link
 */
export const getInAppRoute = (link, currentLocation = window.location) => {
    let url;
    try {
        url = new URL(link, currentLocation.href);
    } catch (error) {
        // sentry-ignore: an unparsable link is opened unchanged by the caller
        void error;
        return null;
    }

    if (url.origin !== currentLocation.origin) return null;
    if (trimTrailingSlash(url.pathname) !== trimTrailingSlash(currentLocation.pathname)) return null;
    if (!url.hash.startsWith("#/")) return null;

    return url.hash.slice(1);
};
